import React from "react";

export default function ModalLayout({
  children,
  open,
  onClose,
  customClass,
  bodyClass,
}) {
  if (!open) {
    return null;
  }

  return (
    <div
      className={`modal fade ${
        customClass ? customClass : "common-modal"
      } show`}
      style={{ opacity: 1, display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className={bodyClass ? bodyClass : "modal-body"}>
            <button onClick={onClose} type="button" class="btn-close" />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
